import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Collapse, Navbar, Menu, MenuHandler, ListItem, MenuItem, MenuList, Typography, Button } from "@material-tailwind/react";
import { BsList, BsFillTelephoneFill, BsFillEnvelopeFill, BsClockFill, BsFacebook, BsInstagram, BsYoutube, BsChevronDown, BsChevronUp } from "react-icons/bs";

import Logo from "../../images/logo.png";
import SelectLanguage from "../../components/SelectLanguage";
import { useTranslation } from "react-i18next";


const Header = () => {
  const { t } = useTranslation();

  // header state
  const [isActive, setIsActive] = useState(false);

  const [openNav, setOpenNav] = useState(false);
  const collapseRef = useRef(null);

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // event listener
  useEffect(() => {
    window.addEventListener("scroll", () => {
      window.scrollY > 60 ? setIsActive(true) : setIsActive(false);
    });

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };


  });


  const handleClickOutside = (event) => {
    if (collapseRef.current && !collapseRef.current.contains(event.target)) {
      setOpenNav(false);
    }
  };


  useEffect(() => {
    window.addEventListener(
      "resize",
      () => window.innerWidth >= 960 && setOpenNav(false),
    );
  }, []);


  // const navList = (
  //   <ul className="mb-4 mt-2 flex flex-col gap-2 lg:mb-0 lg:mt-0 lg:flex-row lg:items-center lg:gap-6 text-info uppercase">
  //     <NavLink to={`/`} onClick={() => setOpenNav(false)}>
  //       {({ isActive }) => (
  //         <Typography
  //           className={`${isActive ?"text-primary": "text-white"} py-2 font-medium hover:opacity-80`}
  //           variant="small"
  //         >
  //           Accueil
  //         </Typography>
  //       )}
  //     </NavLink>

  //     <NavLink to={`/about`} onClick={() => setOpenNav(false)}>
  //       {({ isActive }) => (
  //         <Typography
  //           className={`${isActive ?"text-primary": "text-white"} py-2 font-medium hover:opacity-80`}
  //           variant="small"
  //         >
  //           À propos
  //         </Typography>
  //       )}
  //     </NavLink>

  //     <NavLink to={`/services`} onClick={() => setOpenNav(false)}>
  //       {({ isActive }) => (
  //         <Typography
  //           className={`${isActive ?"text-primary": "text-white"} py-2 font-medium hover:opacity-80`}
  //           variant="small"
  //         >
  //           Services
  //         </Typography>
  //       )}
  //     </NavLink>

  //     <NavLink to={`/production`} onClick={() => setOpenNav(false)}>
  //       {({ isActive }) => (
  //         <Typography
  //           className={`${isActive ?"text-primary": "text-white"} py-2 font-medium hover:opacity-80`}
  //           variant="small"
  //         >
  //           Production
  //         </Typography>
  //       )}
  //     </NavLink>

  //     <NavLink to={`/realizations`} onClick={() => setOpenNav(false)}>
  //       {({ isActive }) => (
  //         <Typography
  //           className={`${isActive ?"text-primary": "text-white"} py-2 font-medium hover:opacity-80`}
  //           variant="small"
  //         >
  //           Réalisations
  //         </Typography>
  //       )}
  //     </NavLink>

  //     <NavLink to={`/contact`} onClick={() => setOpenNav(false)}>
  //       {({ isActive }) => (
  //         <Typography
  //           className={`${isActive ?"text-primary": "text-white"} py-2 font-medium hover:opacity-80`}
  //           variant="small"
  //         >
  //           Contact
  //         </Typography>
  //       )}
  //     </NavLink>
  //   </ul>
  // );

  const navList = (
    <ul className="mb-4 mt-2 flex flex-col gap-2 lg:mb-0 lg:mt-0 lg:flex-row lg:items-center lg:gap-6 text-info uppercase">
      <NavLink to={`/`} onClick={() => setOpenNav(false)}>
        {({ isActive }) => (
          <Typography
            className={`${isActive ?"text-primary": ""} py-2 font-medium hover:opacity-80`}
            variant="small"
          >
            {t('navigation.home')}
          </Typography>
        )}
      </NavLink>

      <NavLink to={`/about`} onClick={() => setOpenNav(false)}>
        {({ isActive }) => (
          <Typography
            className={`${isActive ?"text-primary": ""} py-2 font-medium hover:opacity-80`}
            variant="small"
          >
            {t('navigation.about')}
          </Typography>
        )}
      </NavLink>

      <NavLink to={`/services`} onClick={() => setOpenNav(false)}>
        {({ isActive }) => (
          <Typography
            className={`${isActive ?"text-primary": ""} py-2 font-medium hover:opacity-80`}
            variant="small"
          >
            {t('navigation.services')}
          </Typography>
        )}
      </NavLink>

      <NavLink to={`/production`} onClick={() => setOpenNav(false)}>
        {({ isActive }) => (
          <Typography
            className={`${isActive ?"text-primary": ""} py-2 font-medium hover:opacity-80`}
            variant="small"
          >
            {t('navigation.production')}
          </Typography>
        )}
      </NavLink>

      <NavLink to={`/realizations`} onClick={() => setOpenNav(false)}>
        {({ isActive }) => (
          <Typography
            className={`${isActive ?"text-primary": ""} py-2 font-medium hover:opacity-80`}
            variant="small"
          >
            {t('navigation.realizations')}
          </Typography>
        )}
      </NavLink>

      <NavLink to={`/contact`} onClick={() => setOpenNav(false)}>
        {({ isActive }) => (
          <Typography
            className={`${isActive ?"text-primary": ""} py-2 font-medium hover:opacity-80`}
            variant="small"
          >
            {t('navigation.contact')}
          </Typography>
        )}
      </NavLink>
    </ul>
  );

  return (
    <div className="fixed w-full z-50">

      <Navbar
        fullWidth
        blurred={false}
        // ${isActive ? "py-2" : "py-3" }
        className={`bg-white w-full lg:px-8 transition-all rounded-none shadow-none border-[0px] border-opacity-50 border-b-primary`}
      >
        <div className="mx-auto flex items-center justify-between h-full">
          <div className="flex justify-center items-center">
            <Link to={"/"} className="flex items-center sm:pr-4">
              <img src={Logo} className={`${isActive ? "sm:h-10 h-8" : "sm:h-10 h-8"}`} alt="logo biopack" />
            </Link>
            <div className="hidden lg:block px-5">{navList}</div>
          </div>

          <div className="flex items-center text-primary">

            <SelectLanguage />
            <div className="lg:hidden" onClick={() => setOpenNav(!openNav)}>
              <BsList className="text-3xl" />
            </div>
          </div>
        </div>

        <Collapse open={openNav} ref={collapseRef}>
          <div className="text-center">
            {navList}
          </div>
        </Collapse>
      </Navbar>
    </div>
  );
};

export default Header;
